import React from "react";
// React Table
import { Container, Row, Col, Table } from "react-bootstrap";
// Styled Components
import styled from "styled-components";
// Utils
import { personasAtendidasObj } from "../../../../contexto";

const CustomTd = styled.td`
  background-color: #eeeeee;
`;

const VistaPersonasAtendidas = ({ datosPersonasAtendidas }) => {
  return (
    <Container>
      <Row >
        {Object.keys(personasAtendidasObj).map((tipoPersonasAtendidas) => {
          return datosPersonasAtendidas[tipoPersonasAtendidas]?.nPeopleM !== null || datosPersonasAtendidas[tipoPersonasAtendidas]?.nPeopleF !== null ? (
            <Col key={tipoPersonasAtendidas}>
              <b  className="text-nowrap"> {personasAtendidasObj[tipoPersonasAtendidas]} años</b>
              <Table bordered responsive>
                <thead>
                  <tr>
                    <th>Género</th>
                    <th>Nº personas atendidas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <CustomTd>
                      <span>Varones</span>
                    </CustomTd>
                    <td>{datosPersonasAtendidas[tipoPersonasAtendidas]?.nPeopleM !== null ? datosPersonasAtendidas[tipoPersonasAtendidas]?.nPeopleM : <small>No especificado </small>}</td>
                  </tr>
                  <tr>
                    <CustomTd>
                      <span>Mujeres</span>
                    </CustomTd>
                    <td>{datosPersonasAtendidas[tipoPersonasAtendidas]?.nPeopleF !== null ? datosPersonasAtendidas[tipoPersonasAtendidas]?.nPeopleF : <small>No especificado </small>}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          ) : null;
        })}
      </Row>
    </Container>
  );
};

export default VistaPersonasAtendidas;
